import { render, staticRenderFns } from "./Activitydetail.vue?vue&type=template&id=32cd420c&scoped=true"
import script from "./Activitydetail.vue?vue&type=script&lang=js"
export * from "./Activitydetail.vue?vue&type=script&lang=js"
import style0 from "./Activitydetail.vue?vue&type=style&index=0&id=32cd420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd420c",
  null
  
)

export default component.exports